import { useEffect, useState } from "react";

const ph = () => (typeof window !== "undefined" && window.posthog && typeof window.posthog.opt_out_capturing === "function" ? window.posthog : null);

export const analyticsOptedOut = () => {
  const p = ph();
  return p ? !!p.has_opted_out_capturing() : localStorage.getItem("hwl_analytics_opt_out") === "1";
};

export const setAnalyticsOptOut = (out) => {
  localStorage.setItem("hwl_analytics_opt_out", out ? "1" : "0");
  const p = ph();
  if (!p) return;
  if (out) { p.opt_out_capturing(); if (p.stopSessionRecording) p.stopSessionRecording(); }
  else { p.opt_in_capturing(); if (p.startSessionRecording) p.startSessionRecording(); }
};

// Honors a stored opt-out and the Global Privacy Control signal on every page load.
export const applyAnalyticsPreference = () => {
  const gpc = typeof navigator !== "undefined" && navigator.globalPrivacyControl === true;
  if (gpc || localStorage.getItem("hwl_analytics_opt_out") === "1") {
    const p = ph();
    if (p && !p.has_opted_out_capturing()) { p.opt_out_capturing(); if (p.stopSessionRecording) p.stopSessionRecording(); }
    if (gpc) localStorage.setItem("hwl_analytics_opt_out", "1");
  }
};

export const AnalyticsOptOut = () => {
  const [out, setOut] = useState(false);
  const [ready, setReady] = useState(false);
  useEffect(() => { setOut(analyticsOptedOut()); setReady(true); }, []);
  const toggle = () => { const next = !out; setAnalyticsOptOut(next); setOut(next); };
  const gpc = typeof navigator !== "undefined" && navigator.globalPrivacyControl === true;
  return (
    <div className="border border-white/10 bg-[#141414] p-4 flex flex-wrap items-center justify-between gap-3 not-italic" data-testid="analytics-opt-out">
      <div className="text-sm">
        <p className="text-white font-mono text-xs uppercase tracking-widest">Analytics &amp; session replay</p>
        <p className="text-gray-400" data-testid="analytics-status">{!ready ? "…" : out ? "Disabled in this browser" : "Enabled in this browser"}{gpc ? " · Global Privacy Control detected" : ""}{!ph() && ready ? " · analytics script not loaded" : ""}</p>
      </div>
      <button type="button" onClick={toggle} className="px-4 py-2 border border-white/20 text-white text-xs font-bold uppercase tracking-wide hover:border-signal-red" data-testid="analytics-toggle">
        {out ? "Re-enable analytics" : "Disable analytics"}
      </button>
    </div>
  );
};
